// src/features/executive/sales/hooks/use-payment-method-mix.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import SalesApi from 'api/executive/sales.api'
import type {
  GetPaymentMethodMixParams,
  PaymentMethodMixResponse,
} from 'api/executive/executive.types'

export function usePaymentMethodMix() {
  return useExecutiveQuery<GetPaymentMethodMixParams, PaymentMethodMixResponse>(
    'sales.payment-method-mix',
    SalesApi.getPaymentMethodMix,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        procedureId: f.procedureId ?? undefined,
        txCategoryId: f.txCategoryId ?? undefined,
        patientType: f.patientType ?? undefined,
        appointmentStatus: f.appointmentStatus ?? undefined,
      }
    }
  )
}
